import { PaletteMode, ThemeOptions } from "@mui/material";

// declare custom palette values
declare module "@mui/material/styles" {
  interface TypeBackground {
    white: string;
    code: string;
  }

  interface Palette {
    //exampleColour: PaletteColor;
  }

  interface PaletteOptions {
    //exampleColour: PaletteColorOptions;
  }
}

const palette = (mode: PaletteMode): ThemeOptions["palette"] => ({
  mode,
  ...(mode === "light"
    ? {
        primary: {
          light: "#578a81",
          main: "#4A756E",
          dark: "#3b5e5a",
        },
        secondary: {
          light: "#e8dfd8",
          main: "#c9c2bb",
          dark: "#b5aea8",
        },
        background: {
          default: "#f5f5f5",
          white: "#fff",
          code: "#e6e6e6",
        },
      }
    : {
        primary: {
          light: "#5fb0a3",
          main: "#559e92",
          dark: "#396e65",
        },
        secondary: {
          light: "#5c5854",
          main: "#4a4645",
          dark: "#383635",
          contrastText: "#fff",
        },
        background: {
          default: "#111",
          white: "#1e1e1e",
          code: "#2e2e2e",
        },
      }),
});

export default palette;
